/**
 * Send Request Lock
 *
 * Guards chat sends while a previous request still owns the same chat store.
 *
 * Primary responsibilities:
 * - Block same-chat sends during streaming and post-stream persistence
 * - Keep stale unrelated stores from blocking the current send
 * - Keep stale abort controllers from acting as visible send blockers
 *
 * Dependencies:
 * - none
 */

export type SendRequestActivityState = {
  isGenerating: boolean
  isPersisting: boolean
  startedAt?: number | null
  now?: number
  staleAfterMs?: number
}

export const SEND_REQUEST_STALE_LOCK_MS = 3 * 60 * 1000

export function hasActiveSendRequestActivity(
  state: SendRequestActivityState
): boolean {
  if (!state.isGenerating && !state.isPersisting) {
    return false
  }

  if (!state.startedAt) {
    return true
  }

  const now = state.now ?? Date.now()
  const staleAfterMs = state.staleAfterMs ?? SEND_REQUEST_STALE_LOCK_MS

  return now - state.startedAt < staleAfterMs
}

export function isSendLockedByActiveRequest(
  activeRequestChatStoreKey: string | null,
  requestChatStoreKey: string
): boolean {
  return Boolean(
    activeRequestChatStoreKey &&
      activeRequestChatStoreKey === requestChatStoreKey
  )
}
